import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const WicketModal = ({ show, onHide }) => {
    // This would be a more complex component with logic to select
    // dismissal type, fielders, etc.
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton><Modal.Title>Wicket Details</Modal.Title></Modal.Header>
            <Modal.Body>
                <p>Select dismissal type:</p>
                {/* Add dropdowns/radios for Bowled, Caught, LBW, Run Out etc. */}
                <p>Select Fielder(s) if applicable.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="danger">Confirm Wicket</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WicketModal;
